export default __webpack_public_path__ + "static/media/icon-web.03dc5239.svg";